<template>
    <v-dialog-old ref="dialog" @hidden="reset">
        <fieldset>
            <legend>Причина отклонения</legend>

            <label>
                <input type="radio" v-model="reason" value="Отсутствует ответ на вопрос пациента">
                <span>Отсутствует ответ на вопрос пациента</span>
            </label>

            <label>
                <input type="radio" v-model="reason" value="Рекомендовать консультацию/исследование без развернутого ответа мотивирующего причину такой рекомендации запрещено">
                <span>Рекомендовать консультацию/исследование без развернутого ответа мотивирующего причину такой рекомендации запрещено</span>
            </label>

            <label>
                <input type="radio" v-model="reason" value="Другое">
                <span>Другая причина</span>
            </label>
            <textarea v-model="reasonText" :disabled="reason !== 'Другое'"/>
        </fieldset>

        <footer>
            <button class="green" @click="approveWithoutPayment" :disabled="isBtnDisabled()">Опубликовать без оплаты</button>
        </footer>
    </v-dialog-old>
</template>

<script>
    export default {
        props: {
            answer: {
                type: Object,
                required: true
            },
            uri: {
                type: String,
                required: true
            },
            deletedFiles: {
                type: Array,
                default: () => [],
            },
        },
        data: () => ({
            reason: null,
            reasonText: null,
        }),
        methods: {
            approveWithoutPayment() {
                if (this.isBtnDisabled()) {
                    return;
                }

                let reason = this.reason === 'Другое' ? this.reasonText : this.reason
                this.axios
                    .post(this.uri + 'approve/' + this.answer.id, {
                        text: this.answer.text,
                        deletedFiles: this.deletedFiles,
                        isWithoutPayment: true,
                        withoutPaymentReason: reason,
                    })
                    .then(response => {
                        this.$emit('updatePlease')
                        this.$bus.fire('updateMenu');
                        this.reset()
                        this.$refs.dialog.hide()
                    })
            },
            reset() {
                this.reason = null
                this.reasonText = null
            },
            isBtnDisabled() {
                if (!this.reason) {
                    return true;
                }

                if (this.reason === 'Другое' && !this.reasonText) {
                    return true;
                }
            }
        }
    }
</script>

